// Preserve slow responses while collapsing refreshes into one follow-up request.
export default function coalescedRequest(execute) {
    let active = true, running = false, queued = false, controller;
    const run = async () => {
        if (!active) return;
        if (running) {queued = true; return;}
        running = true;
        controller = new AbortController();
        try {
            await execute(controller.signal);
        } finally {
            running = false;
            if (active && queued) {queued = false; run();}
        }
    };
    return {run, dispose: () => {active = false; controller?.abort();}};
}
